wbApp.factory('domainsSpecializationsSvc', ['$resource', '$q', 'repositorySvc',
    function ($resource, $q, repositorySvc) {
        var Specializations = $resource('/restapi/domains/:id', {}, {
            'get': { method: 'GET', isArray: true, url: '/restapi/domains/:domainId/specializations' },
            'insert': { method: 'POST', url: '/restapi/domains/:domainId/specializations' },
            'update': { method: 'PUT', url: '/restapi/domains/:domainId/specializations/:id' },
            'delete': { method: 'DELETE', url: '/restapi/domains/:domainId/specializations/:id' },
        });

        var domains;

        function getAll(domainId) {            
            return repositorySvc.customGet(
                'get',
                Specializations,
                {
                    domainId: domainId
                });
        }

        function createNew() {
            return {
                name: '',
                description: null
            };
        }

        function insert(domainId, specialization, success, error) {
            return repositorySvc.customPutWithParams(
                'insert',
                Specializations,
                {
                    domainId: domainId
                },
                specialization,
                success,
                error);
        }

        function update(domainId, specialization, success, error) {
            return repositorySvc.customPutWithParams(
                'update',
                Specializations,
                {
                    domainId: domainId,
                    id: specialization.id
                },
                specialization,
                success,
                error);
        }

        function remove(domainId, specialization, success, error) {
            return repositorySvc.customDelete(
                'delete',
                Specializations,
                {
                    domainId: domainId,
                    id: specialization.id
                },
                success,
                error);
        }

        return {
            getAll: getAll,
            createNew: createNew,
            insert: insert,
            update: update,
            remove: remove
        }
    }]);